<template>
  <el-card class="chart-card" shadow="never">
    <template #header>
      <div class="chart-header">
        <span>{{ title }}</span>
        <small>{{ subtitle }}</small>
      </div>
    </template>
    <div v-if="empty" class="chart-empty">
      <el-empty :description="emptyText" />
    </div>
    <div v-else ref="chartRef" class="chart-body"></div>
  </el-card>
</template>

<script>
import { inject, nextTick, onBeforeUnmount, onMounted, ref, watch } from 'vue'

export default {
  name: 'EChartCard',
  props: {
    option: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    empty: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: '暂无图表数据'
    }
  },
  setup(props) {
    const echarts = inject('echarts')
    const chartRef = ref(null)
    let chartInstance = null

    const renderChart = async () => {
      if (props.empty) {
        if (chartInstance) {
          chartInstance.clear()
        }
        return
      }

      await nextTick()

      if (!chartRef.value) {
        return
      }

      if (!chartInstance) {
        chartInstance = echarts.init(chartRef.value)
      }

      chartInstance.setOption(props.option, true)
    }

    const resizeChart = () => {
      if (chartInstance) {
        chartInstance.resize()
      }
    }

    onMounted(() => {
      renderChart()
      window.addEventListener('resize', resizeChart)
    })

    watch(
      () => props.option,
      () => {
        renderChart()
      },
      { deep: true }
    )

    watch(
      () => props.empty,
      () => {
        renderChart()
      }
    )

    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeChart)
      if (chartInstance) {
        chartInstance.dispose()
      }
    })

    return {
      chartRef
    }
  }
}
</script>

<style scoped>
.chart-card {
  border-radius: 22px;
  border: 1px solid rgba(148, 163, 184, 0.18);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(248, 250, 252, 0.96));
}

.chart-header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
  font-weight: 700;
  color: #172554;
}

.chart-header small {
  color: #64748b;
}

.chart-body {
  height: 320px;
}

.chart-empty {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
